<!--  -->
<template>
  <div>
    <el-table
      :data="failarr"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="account_name"
        label="公众号失败"
        width="180"
      />
      <el-table-column
        prop="app_id"
        label="appid"
        width="180"
      />
      <el-table-column
        prop="reason"
        label="失败原因"
      />
    </el-table>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      failarr: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(failarrr) {
      console.log('failarrr', failarrr)
      this.failarr = failarrr
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
